import { Link, useLocation } from 'react-router-dom';
import { Home, Search, ShoppingCart, Heart, ShoppingBag } from 'lucide-react';
import { useCartStore } from '../../lib/cartStore';
import { useAuthStore } from '../../lib/authStore';

export default function BottomNav() {
  const location = useLocation();
  const itemCount = useCartStore((s) => s.getItemCount());
  const { isAuthenticated } = useAuthStore();
  const path = location.pathname;

  if (path.startsWith('/admin')) return null;

  const navItems = [
    { to: '/', icon: Home, label: 'Início', testid: 'bnav-home' },
    { to: '/produtos', icon: Search, label: 'Catálogo', testid: 'bnav-catalog' },
    { to: '/carrinho', icon: ShoppingCart, label: 'Carrinho', testid: 'bnav-cart', badge: itemCount },
    { to: '/favoritos', icon: Heart, label: 'Favoritos', testid: 'bnav-favorites' },
    { to: isAuthenticated ? '/pedidos' : '/login', icon: ShoppingBag, label: isAuthenticated ? 'Pedidos' : 'Entrar', testid: 'bnav-orders' },
  ];

  return (
    <nav data-testid="bottom-nav" className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#09090B] border-t-2 border-red-600 safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = path === item.to || (item.to !== '/' && path.startsWith(item.to));
          return (
            <Link key={item.testid} to={item.to} data-testid={item.testid}
              className={`flex flex-col items-center justify-center gap-0.5 px-3 py-1 relative transition-colors ${active ? 'text-red-500' : 'text-zinc-500 hover:text-zinc-300'}`}>
              <div className="relative">
                <Icon className="h-5 w-5" />
                {item.badge > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[9px] font-bold rounded-full h-4 w-4 flex items-center justify-center">{item.badge}</span>
                )}
              </div>
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
